import { IMarketplaceInventoryInput, IVendorInventoryUploadInput } from '@admin-panel/types';
import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { CrudFilters, CrudSort, MetaQuery } from '@refinedev/core';
import { axiosInstance } from './axios';

class InventoryApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/inventory');
  }

  override async createMany<T = unknown>(
    payload: Array<Partial<T>>,
    meta: MetaQuery | undefined,
  ): Promise<Array<T>> {
    try {
      const uploadPayload = payload as unknown as Array<IVendorInventoryUploadInput>;
      const invRows: Array<IMarketplaceInventoryInput> = uploadPayload.map(
        (inv: IVendorInventoryUploadInput) => {
          const rawQuantity =
            inv.updatedInventory !== undefined && String(inv.updatedInventory).trim() !== ''
              ? inv.updatedInventory
              : inv.warehouseInventory;
          const quantity = Number(rawQuantity);
          if (!Number.isInteger(quantity) || quantity < 0) {
            throw new Error('Warehouse Inventory must be a non-negative integer');
          }
          const baseData = {
            quantity,
            vendorId: meta?.vendorId,
            facilityCode: meta?.unicomFacilityCode,
          };

          if (meta?.useVendorSkuCode) {
            return {
              ...baseData,
              vendorSkuCode: inv.vendorSkuCode || inv.skuCode,
            };
          } else {
            return {
              ...baseData,
              skuCode: inv.skuCode,
            };
          }
        },
      );

      const response = await axiosInstance.post(`${this.baseURL}/upload`, invRows);
      return this.transformList(response.data.data) as Array<T>;
    } catch (error) {
      console.error(`Error uploading entities in bulk:`, error);
      throw error;
    }
  }

  async updateWarehouseInventory(
    _sorters: Array<CrudSort>,
    _filters: CrudFilters,
    payload: { warehouseInventory: number },
    _query: unknown,
    _headers: unknown,
    meta: MetaQuery | undefined,
  ): Promise<unknown> {
    try {
      if (!meta?.inventoryId) {
        throw new Error('inventoryId is required to update warehouse inventory');
      }
      const response = await axiosInstance.put(
        `${this.baseURL}/${meta?.inventoryId}/warehouse-inventory`,
        payload,
      );
      if (response.data?.success === false) {
        throw new Error(response.data?.status?.message || 'Failed to update warehouse inventory');
      }
      return this.transformNode(response.data.data);
    } catch (error) {
      console.error(`Error updating warehouse inventory:`, error);
      throw error;
    }
  }
}

export default InventoryApiClient;
